export const TeamsIdTokenKeyPrefix = "ME_MSTIDT";
export const TeamsGraphTokenKeyPrefix = "ME_MSTGT";
export const APIMSubscriptionKeyHeader = "Ocp-Apim-Subscription-Key";
export const APIM_BASE_URL = process.env.APIM_BASE_URL;
